import request from '../helpers/request';
import {
  barLogAPI,
  getUserSessionAPI,
  IncreaseUserSessionAPI,
  movieLogAPI,
  pageChangeLogAPI,
} from '../helpers/api';
import store from '../store/store';

export const getUserSession = async (data) => {
  return await request(getUserSessionAPI(), 'GET', data, {
    frontType: store.getters.frontType,
  });
};

export const IncreaseUserSession = async (userSessionGuid) => {
  console.log(userSessionGuid);
  return await request(IncreaseUserSessionAPI(), 'POST', null, { userSessionGuid });
};

export const barLog = async (data, userSessionGuid) => {
  return await request(barLogAPI(), 'POST', data, { userSessionGuid });
};

export const movieLog = async (data, userSessionGuid) => {
  return await request(movieLogAPI(), 'POST', data, { userSessionGuid });
};

export const pageChangeLog = async (data, userSessionGuid) => {
  console.log(userSessionGuid, 'userSessionGuid');

  return await request(pageChangeLogAPI(), 'POST', data, {
    frontType: store.getters.frontType,
    userSessionGuid,
  });
};
